/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  idPlantaoVendas: string | undefined | null;
  codigoTurno: string | number;
  idRoletaCheckin?: string;
}

export function useListarFilaRecepcionista(props: Props) {
  const idRoletaCheckin =
    props.idRoletaCheckin && `&IdRoletaCheckin=${props.idRoletaCheckin}`;
  const LISTAR_FILA = `${leadsWebEnviroment}/common/checkin/recepcao/listar-fila/v1?IdPlantaoVendas=${props.idPlantaoVendas}&CodigoTurno=${props.codigoTurno}${idRoletaCheckin}`;
  const fetchData = async () => {
    const response = await instance.get(LISTAR_FILA);
    return response?.data?.data;
  };
  const query = useQuery({
    queryFn: fetchData,
    queryKey: [
      "listar-fila-recepcionista",
      props.idPlantaoVendas,
      props.codigoTurno,
      props.idRoletaCheckin,
    ],
    refetchOnWindowFocus: false,
    enabled: !!(props.idPlantaoVendas && props.codigoTurno),
    // refetchInterval: 60000,
    retry: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao listar fila. Motivos:\n ${error.response.data.notifications?.map(
          (item: any) => `${item?.message}`
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
